import {
  AuthorizationFailedReason,
  IncidentType
} from "@moderrotech/servers-communication-library/src/types";

export const ca = {
  topics: {
    headerTitle: "Temes",
    search: "Cerca",
    noTopics: "No s'han trobat temes",
    notFound: "No s'ha trobat cap tema que coincideixi amb el patró",
    schedule: {
      closed: "Estem tancats"
    },
    customerInfoForm: {
      title: "Per iniciar una videotrucada, omple el formulari",
      description:
        "Abans d'utilitzar el servei de banca per vídeo per sol·licitar el vostre préstec, si us plau, empleneu el formulari.",
      optional: "Opcional",
      buttons: {
        cancel: "Cancel·lar",
        submit: "Inicia la videotrucada"
      }
    }
  },
  call: {
    calling: "Trucant...",
    joining: "Adhesió a la convocatòria",
    transferring: "Transferència de la trucada",
    aspectRatio: "Zoom",
    cancel: "Cancel·la la trucada",
    end: "Cancel·lar",
    share: "Trucada multipartícipe",
    document: "Document",
    actions: "Accions",
    closeActions: "Cancel · lar",
    mute: "Silenciar",
    unmute: "Activa el so",
    textMessage: "Missatge de text",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return `Ets ${
        isPositionAvailable ? `el número ${position} ` : ""
      } a la cua`;
    },
    ticket: "Bitllet",
    camera: {
      enable: "Activa la càmera",
      disable: "Desactiva la càmera"
    },
    hangupRequest: {
      title: "Estàs segur?",
      body: "Realment vols desconnectar?",
      yes: "Sí, penja",
      no: "No, torna a la trucada"
    },
    downloadFileRequest: {
      title: "L'agent ha compartit un fitxer amb tu",
      yes: "Descarregar",
      no: "Descartar"
    },
    openUrlRequest: {
      title: "Obre l'URL",
      body: "L'expert vol obrir un URL en una pestanya nova",
      yes: "Obre l'URL",
      no: "Cancel · lar"
    },
    lowPerformanceNotification: {
      title:
        "Sembla que el teu dispositiu té un rendiment baix. Si us plau, no utilitzeu la càmera per evitar que l'aplicació es bloquegi",
      gotIt: "Ho tinc"
    },
    signaturePad: {
      submit: "Presentar",
      clear: "Netejar",
      cancel: "Cancel · lar"
    },
    paintover: {
      submit: "Presentar",
      clear: "Netejar",
      cancel: "Cancel · lar"
    },
    textMessageForm: {
      placeholder: "Missatge"
    },
    recordTranslator: {
      transcribing: "Parla, si us plau"
    },
    cameraSnapshot: {
      title: "Instantània de la càmera"
    },
    mediaInputsAccessNote: {
      title: "Permet l'accés al micròfon i a la càmera",
      description:
        "Cerqueu una petita finestra emergent a prop de la barra d'adreces del vostre navegador."
    },
    animatedCharacter: {
      listening: {
        title: "L'agent està escoltant",
        description: "Ja podeu parlar. Digueu la pregunta o sol·licitud."
      },
      thinking: {
        title: "L'agent està pensant",
        description: "Si us plau, espereu mentre l'agent cerca una resposta."
      }
    },
    success: {
      document: "El document s'ha enviat correctament",
      feedback: "S'ha enviat un comentari",
      textMessage: "Missatge de text",
      signaturePad: "S'ha enviat la signatura",
      paintover: "La imatge ha estat enviada",
      textCopy: "El text s'ha copiat al porta-retalls",
      imageCopy: "La imatge s'ha copiat al porta-retalls",
      callSharing: "L'enllaç s'ha copiat al porta-retalls"
    },
    error: {
      base:
        "Alguna cosa ha anat malament. Si us plau, torneu a carregar la pàgina",
      mediaInputsAccess:
        "No es pot accedir al micròfon i/o la càmera. Si us plau, activeu-los a la configuració",
      join: "No es pot unir a la trucada",
      document: "No es pot enviar el document",
      noExperts: "No hi ha experts disponibles",
      noTopic: "El tema ja no està disponible",
      queueSuspended:
        "S'ha suspès la cua<br>En aquests moments no podem atendre trucades noves. Si us plau, torna-ho a provar més tard.",
      queueOverloaded:
        "La cua s'ha sobrecarregat<br>Estem experimentant un gran volum de trucades. Si us plau, torna-ho a provar més tard.",
      timeout: "Esperar un expert massa temps",
      documentSize: "El document és massa gran",
      feedback: "Alguna cosa ha anat malament",
      noRoom: "La cita ha caducat o ha estat cancel·lada",
      textMessage: "El missatge de text no es pot enviar",
      signaturePad: "La signatura no es pot enviar",
      paintover: "Error d'enviament de la imatge",
      textCopy: "No es pot copiar el text",
      imageCopy: "No es pot copiar la imatge",
      callSharing: "No es pot compartir l'enllaç",
      recordTranslation: {
        play: "No es pot reproduir l'àudio de la traducció",
        streamGetting: "No es pot obtenir la reproducció d'àudio",
        transcription: "No es pot transcriure el registre",
        translation: "No es pot traduir el registre",
        unsupportedLanguage:
          "S'ha seleccionat que no s'admet per al TEU idioma de traducció d'àudio. Però l'àudio de l'expert es pot traduir en aquest idioma"
      },
      geolocation: "No es pot obtenir la geolocalització",
      cameraSnapshot: "No es pot fer una instantània de la càmera"
    },
    onHold: {
      title: "En espera.",
      description: "L'agent us respondrà en breu."
    },
    remoteActionRequest: {
      shareFile: {
        title:
          "L'expert vol compartir un fitxer des del vostre dispositiu. Permetre?",
        yes: "Sí",
        no: "No"
      },
      screenSharing: {
        title: "L'expert vol veure la teva pantalla. Permetre?",
        yes: "Sí",
        no: "No"
      }
    },
    settings: {
      title: "Configuració",
      labels: {
        camera: "Càmera",
        microphone: "Micròfon"
      }
    }
  },
  thank: {
    toTopics: "Tornar als temes",
    redirect: "A cita"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "S'ha acabat el temps."
          : "No hi ha experts disponibles per respondre la vostra trucada.";
      },
      body:
        "Podeu deixar un missatge als vostres agents perquè es posin en contacte amb vosaltres tan aviat com estiguin disponibles",
      yes: "Crea un bitllet",
      no: "No gràcies"
    },
    form: {
      labels: {
        phone: "Telèfon",
        email: "Correu electrònic",
        message: "Missatge"
      },
      buttons: {
        cancel: "Cancel · lar",
        submit: "Enviar un missatge"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "De:",
          validation: {
            label: "correu electrònic"
          }
        },
        message: {
          label: "missatge",
          placeholder: "Missatge",
          validation: {
            label: "missatge"
          }
        }
      },
      buttons: {
        submit: "Enviar",
        cancel: "Cancel·la",
        open: "Afegeix un missatge de comentaris..."
      },
      notifications: {
        success: "S'ha enviat un informe d'error"
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "L'agent es queda amb tu i et parlarà en un moment."
          : "S'ha perdut la connexió. S'està tornant a connectar...";
      },
      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "Estem a punt de restablir la teva connexió."
          : "S'ha perdut la connexió del servidor. S'està tornant a connectar...";
      },
      code: "Codi: 503"
    },
    login: {
      credentials: "Nom d'usuari o contrasenya incorrectes",
      default: "Alguna cosa ha anat malament"
    },
    unpublished: {
      title: "L'aplicació no existeix.",
      description:
        "És possible que s'hagi cancel·lat temporalment o s'hagi suprimit de manera permanent.",
      code: "Codi: 404"
    },
    authorization: {
      title: "Accés prohibit",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "L'aplicació no està disponible al vostre país o regió.",
          [AuthorizationFailedReason.noLicense]: "Sense llicència assignada.",
          [AuthorizationFailedReason.remStopped]: "Servei no disponible.",
          [AuthorizationFailedReason.noPtpcResponse]:
            "Cap resposta del servidor."
        }[reason];
      },
      code: "Codi: 403"
    },
    network: {
      title: "Si us plau, assegureu-vos que teniu accés a Internet"
    }
  },
  validation: {
    phone: "El camp {field} ha de ser un número de telèfon vàlid",
    dni: "ID incorrecte, format no vàlid",
    nie: "ID incorrecte, format no vàlid"
  }
};
